import type { JuneauTheme } from 'juneau';

/**
 * Tappeer design-system color tokens mapped to Juneau CSS variables.
 * Uses CSS custom properties so they resolve from the active Tappeer theme at runtime.
 */
export const tappeerTheme: JuneauTheme = {
  colorPrimary: 'var(--color-primary-base)',
  colorPrimaryDark: 'var(--color-primary-hover, var(--color-primary-base))',
  colorPrimaryLight: 'var(--color-background-muted)',
  colorPrimaryBorder: 'var(--color-border-base)',
  colorAccent: 'var(--color-secondary-base)',
  colorAccentDark: 'var(--color-secondary-hover, var(--color-secondary-base))',
  colorAccentLight: 'var(--color-background-muted)',
  colorAccentBorder: 'var(--color-border-base)',
  colorSurface: 'var(--color-background-input)',
  // Assistant bubble, table headers and activity rows — one step lighter than
  // `background-muted` so they match the result cards. Hover keeps the darker step.
  colorSurfaceRaised: 'var(--color-background-base)',
  colorSurfaceHover: 'var(--color-background-muted)',
  colorBorder: 'var(--color-border-base)',
  colorBorderSubtle: 'var(--color-border-input)',
  colorTextPrimary: 'var(--color-foreground-base)',
  colorTextSecondary: 'var(--color-foreground-muted)',
  colorTextMuted: 'var(--color-foreground-muted)',
  colorTextFaint: 'var(--color-foreground-disabled)',
  colorTextInverse: 'var(--color-foreground-white)',
  // Pink hero disc behind the brand mark, matching the header chip.
  colorAssistantAvatar: 'var(--color-secondary-base)',

  // Semantic states — badges and the error banner follow the app's own palette.
  colorErrorBg: 'var(--color-error-bg)',
  colorErrorBorder: 'var(--color-error-border)',
  colorErrorText: 'var(--color-error-text)',
  colorSuccessBg: 'var(--color-success-bg)',
  colorSuccessText: 'var(--color-success-text)',
  colorWarningBg: 'var(--color-warn-bg)',
  colorWarningText: 'var(--color-warn-text)',
  colorDangerBg: 'var(--color-error-bg)',
  colorDangerText: 'var(--color-error-text)',

  // Softer, rounder geometry than Juneau's defaults.
  radiusSm: '8px',
  radiusMd: '12px',
  radiusLg: '18px',
  radiusFull: '9999px',

  // One step up from Juneau's compact defaults for easier reading.
  fontSizeXs: '11px',
  fontSizeSm: '12px',
  fontSizeBase: '13px',
  fontSizeMd: '14px',
  fontSizeLg: '16px',
  fontSizeXl: '18px',
  fontFamily: 'inherit',
  transitionFast: '0.18s'
};
